module.exports = __webpack_public_path__ + "2ac160305cd38b64d87f1bc3ed91cc5b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/owl-ffel-tower.png
// module id = 572
// module chunks = 0